import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { MY_TURN_CONTROLS_ANIMATION_SET } from '../../../../animations/animationDefinitions';
import { selectIsSimpleBettingEnabled } from '../../../../redux/reducers/pokerReducer';
import { useAppSelector } from '../../../../redux/store';
import { AnimationContainer } from '../../pixiComponents/animationContainer';
import { PixiAutoBetControls } from './pixiAutoBetControls';
import { PixiDiscardControls } from './pixiDiscardControls';
import { PixiSimpleBetControls } from './pixiSimpleBetControls';
import { PixiStandardBetControls } from './pixiStandardBetControls';
export const PixiBetControlsRouter = () => {
    const isSimpleBettingEnabled = useAppSelector(selectIsSimpleBettingEnabled);
    const isMyDiscardTurn = useAppSelector((state) => state.poker.isMyDiscardTurn);
    const myTurnProperties = useAppSelector((state) => state.poker.myTurnProperties, shallowEqual);
    const isMyAutoBetTurn = useAppSelector((state) => !!state.poker.autoBetProperties);
    if (isMyDiscardTurn) {
        return _jsx(PixiDiscardControls, {});
    }
    if (myTurnProperties) {
        return (_jsx(AnimationContainer, { startTimestampMs: myTurnProperties.startTimestampMs, animationSet: MY_TURN_CONTROLS_ANIMATION_SET, children: isSimpleBettingEnabled ? (_jsx(PixiSimpleBetControls, { myTurnProperties: myTurnProperties })) : (_jsx(PixiStandardBetControls, { myTurnProperties: myTurnProperties })) }));
    }
    /**
     * TODO: Enable auto betting controls with simple betting, which requires aligning button bounds so unintended
     * betting actions won't occur if the buttons change as the player is about to click something.
     */
    if (isMyAutoBetTurn && !isSimpleBettingEnabled) {
        return _jsx(PixiAutoBetControls, {});
    }
    return null;
};
